import { Renta, TiposAlojamientos } from 'src/gql/schema'
import { useFormatDate } from 'src/shared/hooks/useFormatDate'
import { useDate } from 'src/shared/hooks/useDate'
import useIsColaboradorActive from 'src/shared/hooks/useIsColaboradorActive'
import { useProfile } from 'src/shared/hooks/useProfile'
import { RoleNames } from 'src/shared/hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailIcon from 'src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import DetailAction from 'src/shared/components/data-display/Detail/kit/DetailAction/DetailAction'
import { add, times } from 'src/shared/helpers/calculator'

const FechaEstancia = ({ ultima_renta, habitacion_id, noches_extras_enabled }: { ultima_renta: Renta, habitacion_id: string, noches_extras_enabled: boolean }) => {
    const { rolName } = useProfile()
    const navigate = useNavigate()

    const { formatCustomDate } = useFormatDate()
    const { diffDays, UTCStringToLocalDate } = useDate()

    const noches = diffDays(UTCStringToLocalDate(ultima_renta.fecha_registro), UTCStringToLocalDate(ultima_renta.fecha_fin))
    const hospedajesExtra = ultima_renta.hospedajes_extra || 0
    const horasExtra = ultima_renta.horas_extra || 0

    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()


    const isAlojamientoHotel = ultima_renta.tarifas?.some(t => t.tipo_alojamiento === TiposAlojamientos.Hotel)

    const getHospedajeExtraText = () => {
        if (isAlojamientoHotel) {
            return ((hospedajesExtra > 0 ? `+ ${hospedajesExtra} noche${hospedajesExtra > 1 ? "s" : ""}` : "") + (horasExtra > 0 ? `${hospedajesExtra > 0 ? " y " : "+"} ${horasExtra} hora${horasExtra > 1 ? "s" : ""}` : ""))
        }
        const totalHoras = add(times(hospedajesExtra, ultima_renta.tarifas?.[0]?.grupo_tarifa?.duracion || 0), horasExtra)
        return ((totalHoras > 0 ? `+ ${totalHoras} hora${totalHoras > 1 ? "s" : ""}` : ""))
    }

    return (
        // TODO 1: DESACTIVAR CUANDO NO TIENE LA FUNCIONALIDAD DE AGREGAR EXTRAS
        <Detail color="white">
            <DetailIcon name="calendarFill" />
            <DetailContent>
                <DetailRow>
                    <DetailText type="normal">
                        Fecha de estancia
                    </DetailText>
                    {
                        ![RoleNames.mantenimiento, RoleNames.monitoreo].includes(rolName as unknown as RoleNames) &&
                        <DetailAction disabled={!noches_extras_enabled} onClick={validateIsColabActive(() => navigate(`detalle-habitacion/extension/${habitacion_id}`))}>
                            Agregar
                        </DetailAction>
                    }
                </DetailRow>
                {
                    isAlojamientoHotel &&
                    <DetailRow>
                        <DetailText type="bold">
                            {`${formatCustomDate(
                                ultima_renta?.fecha_registro,
                                "MMM, DD YYYY"
                            )} - ${formatCustomDate(ultima_renta?.fecha_condensada, "MMM, DD YYYY")}`}
                        </DetailText>
                    </DetailRow>
                }
                <DetailRow>
                    {
                        isAlojamientoHotel ?
                            <DetailText type="normal">
                                {noches} {`noche${noches > 1 ? "s" : ""}`}
                            </DetailText> :
                            <DetailText type="normal">
                                {ultima_renta.tarifas?.[0]?.grupo_tarifa?.duracion || 0} {`hora${ultima_renta.tarifas?.[0]?.grupo_tarifa?.duracion || 0 < 1 ? "s" : ""}`}
                            </DetailText>
                    }
                </DetailRow>
                {
                    !!getHospedajeExtraText().length &&
                    <DetailRow>
                        <DetailText type="normal">
                            {getHospedajeExtraText()}
                        </DetailText>
                    </DetailRow>
                }
            </DetailContent>
            {InactiveModal}
        </Detail>
    )
}

export default FechaEstancia
